import ModelSocket from '~/src/model-socket.js';

class ExamAnswer extends ModelSocket {

  constructor(socket, store) {
    super(socket, store);
    this.channelName = 'exam_answers';
  }

}

export default ExamAnswer;
